import script from "./MakerCartGuide6Page.vue?vue&type=script&setup=true&lang=js"
export * from "./MakerCartGuide6Page.vue?vue&type=script&setup=true&lang=js"

import "./MakerCartGuide6Page.vue?vue&type=style&index=0&id=daa2909e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-daa2909e"]])

export default __exports__